export enum UserGroups {
  ADMIN = 'ADMIN',
  EDUCATOR = 'EDUCATOR',
  TEACHER = 'TEACHER',
  DISCIPLINARY = 'DISCIPLINARY',
  PARENT = 'PARENT',
  STUDENT = 'STUDENT'
}
